import React, {useEffect, useState, useContext} from 'react'
import Ajax from '../../../../helpers/Ajax'
import Button from '../../../UI/Form/Button'
import FormGroup from '../../../UI/Form/FormGroup'
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import Pagination from '../../../UI/Dashboard/Pagination';
import TableLoader from '../../../UI/Dashboard/TableLoader';
import DataView from '../../../UI/Dashboard/DataView';
import TableContainer from '../../../UI/Dashboard/TableContainer';
import PaginationContainer from '../../../UI/Dashboard/PaginationContainer';
import ViewButton from '../../../UI/Dashboard/ViewButton';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import FilterOptions from '../../../../helpers/FilterOptions';
import FilterLayout from '../../../UI/Dashboard/FilterLayout';
import ContentLayout from '../../../Common/ContentLayout';
import DeleteButton from '../../../UI/Dashboard/DeleteButton';
import moment from 'moment/moment';

export default function ShortlistPropertyUsers() {
    const [service, setService] = useState(null)
    const [totalResult, setTotalResult] = useState(null)
    const [totalRow, setTotalRows] = useState(null)
    const [newpage, setNewPage] = useState(false)
    const [search, setSearch] = useState(false)
    const [initialPage, setInitialPage] = useState(0)
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const [currentPage, setCurrentPage] = useState(searchParams.get('page'))
    const pageParams = searchParams.get('page')
    const navigate = useNavigate()
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/buyer/allShortList${newpage !== false ? `?pagination=${newpage}` : ''}${pageParams && newpage === false ? `?pagination=${pageParams}` : ''}${Object.keys(filterKey).length === 0 ? '' : `&${new URLSearchParams(filterKey)}`}`,
            token: true,
            ...(pageParams && {loader: true})
        })
        if(response.data.status === "SUCCESS!"){
            setService(response.data.result)
            setTotalResult(response.data.countData)
            setTotalRows(response.data.countData / 10)
            setInitialPage(pageParams)
            setCurrentPage(searchParams.get('page'))
        }
        
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[location])

    //Filters
    const [filterKey, setFilterKey] = useState({})
    const setFilter = (e) => {
        const fieldName = e.target.getAttribute("name")
        let updatedValue = {};
        if(e.target.value.trim().length === 0) {
            delete filterKey[fieldName]
            return false
        }
        updatedValue[fieldName] = e.target.value.trim()
        setFilterKey(oldValue => ({...oldValue, ...updatedValue}));
    }

    const filterHandler = async() => {
        const filterResponse = await Ajax({
            url: '/product?' + new URLSearchParams(filterKey),
            token: true,
            loader: true
        })
        if(filterResponse.data.result.length === 0){
            setService(filterResponse.data.result)
            toast.error('Matching Record not found!',{
                autoClose: 1500
            })
            setSearch(true)
        }else{
            setCurrentPage(0)
            setInitialPage(0)
            setService(filterResponse.data.result)
            setTotalRows(filterResponse.data.countData / 10)
            setTotalResult(filterResponse.data.countData)
            pageParams && navigate('/admin/home/service')
            return false
        }
    }

    return (
    <ContentLayout title='Shortlist Property Users'>
        <div className="row">
        <Helmet>
            <title>Shortlist Property Userst</title>
        </Helmet>
        {/* {service == null ? '' : (service.length > 0 || search === true) &&
        <FilterLayout>
            <div className='row'>
                <div className='col-md-3'>
                    <FormGroup label="Employee Name (First Name)">
                        <input type="text" name="firstName" placeholder="Employee Name" onChange={setFilter} className="form-control" />
                    </FormGroup>
                </div>
                <div className='col-md-3'>
                    <FormGroup label="E-Mail">
                        <input type="text" name="email" placeholder="E-Mail" className="form-control" onChange={setFilter}  />
                    </FormGroup>
                </div>
                <div className='col-md-3'>
                    <FormGroup label="Employee Code">
                        <input type="number" name="empCode" placeholder="Employee Code" className="form-control" onChange={setFilter}  />
                    </FormGroup>
                </div>
            </div>
            <div className="col-md-2 d-grid">
                <Button type="button" icon="fas fa-filter" onclick={filterHandler}>Filter</Button>
            </div>
        </FilterLayout> } */}
        <DataView title="Shortlist">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">User Name</td>
                        <td className="text-center">User Email</td>
                        <td className="text-center">User Phone</td>
                        <td className="text-center">Property</td>
                        <td className="text-center">Unit Number</td>
                        <td className="text-center">BHK</td>
                        <td className="text-center" width={100}>Date / Time</td>
                        <td className="text-center">View</td> 
                    </tr>
                </thead>
                <tbody>
                    {service == null ? 
                    <TableLoader cols={9}/> : service.length === 0 ? 
                    <tr>
                        <td colSpan={9} className="text-center">Data not available</td>
                    </tr> : service.map((data, index)=>(
                    <tr key={data._id}>
                        <td className="text-center">{currentPage ? ((index + 1) + Number(currentPage) * 1 * 10) : index + 1}</td>
                        <td className="text-start">{data.userDetails && data.userDetails.length > 0 && data.userDetails[0].name ? data.userDetails[0].name : 'NA'}</td>
                        <td className="text-start">{data.userDetails && data.userDetails.length > 0 && data.userDetails[0].email ? data.userDetails[0].email : 'NA'}</td>
                        <td className="text-center">{data.userDetails && data.userDetails.length > 0 && data.userDetails[0].phoneNumber ? data.userDetails[0].phoneNumber : 'NA'}</td>
                        <td className="text-center">{data.productDetails && data.productDetails.length > 0 && data.productDetails[0].name ? data.productDetails[0].name : 'NA'}</td>
                        <td className="text-center">{data.productDetails && data.productDetails.length > 0 && data.productDetails[0].unitNumber ? data.productDetails[0].unitNumber : 'NA'}</td>
                        <td className="text-center">{data.bhkDetails && data.bhkDetails.length > 0 && data.bhkDetails[0].name ? data.bhkDetails[0].name : 'NA'}</td>
                        <td className="text-center">{moment(data.createdAt).format('DD MMM YYYY')}<br/>{moment(data.createdAt).format('HH:mm')}</td>
                        <td className="text-center">
                            <ViewButton>{`/admin/shortlist-users/${data._id}`}</ViewButton>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
            <PaginationContainer count={totalResult}>
                <Pagination totalPage={totalRow} url='/admin/shortlist-users' currentPage={initialPage}  />
            </PaginationContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
